var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-access"},[_c('div',{staticClass:"has-text-centered"},[_vm._m(0),_c('p',{staticClass:"is-size-1"},[_vm._v("403")]),_c('p',{staticClass:"is-size-4"},[_vm._v(_vm._s(_vm.localization("app-no-access", "No Access")))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('i',{staticClass:"fa fa-lock fa-4x"})])
}]

export { render, staticRenderFns }